export const parseArrayValue = (value) => {
  if (Array.isArray(value)) return value;
  if (value === null || value === undefined || value === '') return [];

  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed;
    } catch {
      return value.split(',').map((entry) => entry.trim()).filter(Boolean);
    }
  }

  return [];
};

export const normalizeCategories = (value) => parseArrayValue(value)
  .map((category) => {
    if (category && typeof category === 'object') {
      return category.label || category.name || category.id || category.value || '';
    }
    return String(category || '').trim();
  })
  .filter(Boolean);

export const normalizeAllergens = (value) => parseArrayValue(value)
  .map((allergen) => {
    if (allergen && typeof allergen === 'object') {
      const id = allergen.id || allergen.value || allergen.label || allergen.name || '';
      const label = allergen.label || allergen.name || allergen.id || allergen.value || '';
      return { id: String(id), label: String(label) };
    }

    const text = String(allergen || '').trim();
    return text ? { id: text, label: text } : null;
  })
  .filter(Boolean);

export const normalizeListing = (listing) => ({
  ...listing,
  providerId: listing.providerId || listing.provider_id,
  providerName: listing.providerName || listing.provider_name,
  imageUrl: listing.imageUrl || listing.image_url,
  image_url: listing.image_url || listing.imageUrl,
  cookedAt: listing.cookedAt || listing.cooked_at,
  cookedTimeOfDay: listing.cookedTimeOfDay || listing.cooked_time_of_day,
  expDate: listing.expDate || listing.exp_date,
  expTimeOfDay: listing.expTimeOfDay || listing.exp_time_of_day,
  isAnonymous: listing.isAnonymous ?? listing.is_anonymous ?? false,
  categories: normalizeCategories(listing.categories),
  allergens: normalizeAllergens(listing.allergens),
});

export const normalizeCommercialOffer = (offer, providers = []) => {
  const provider = providers.find((entry) => String(entry.id) === String(offer.provider_id));
  return {
    ...offer,
    providerId: offer.providerId || offer.provider_id,
    providerName: offer.providerName || offer.provider_name || provider?.name,
    provider_name: offer.provider_name || offer.providerName || provider?.name,
    imageUrl: offer.imageUrl || offer.image_url,
    image_url: offer.image_url || offer.imageUrl,
    logo_url: offer.logo_url || provider?.logo_url,
    address: offer.address || provider?.address,
    lat: offer.lat || provider?.lat,
    lng: offer.lng || provider?.lng,
    categories: normalizeCategories(offer.categories),
    weekly_menu: parseArrayValue(offer.weekly_menu),
    isCommercial: true,
  };
};
